import ClientForm, { ClientFormValues } from 'components/featured/Client/ClientForm/ClientForm';
import ClientFormPage from 'components/featured/Client/ClientFormPage';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HuddleClientService } from 'service/huddle-client.service';
import { CreateClientV2Payload } from 'model/client.model';

const ClientNew = () => {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState<ClientFormValues | null>(null);
  const [isValid, setIsValid] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (values: ClientFormValues, valid: boolean) => {
    setFormValues(values);
    setIsValid(valid);
  };

  const handleSubmit = async () => {
    if (!formValues || !isValid) return;
    setSubmitting(true);
    try {
      const payload: CreateClientV2Payload = {
        name: formValues.clientName,
        clientType: formValues?.clientType?.toLocaleLowerCase(),
        classification: formValues.league ? [formValues.league] : undefined,
        industry: formValues.position || undefined,
        agency: formValues.agency || undefined,
        personEmail: formValues.email || undefined,
        personMobilePhone: formValues.mobile || undefined,
        ...((formValues.billingStreet ||
          formValues.billingCity ||
          formValues.billingState ||
          formValues.billingCountry ||
          formValues.billingZip) && {
          billingAddress: {
            street: formValues.billingStreet || undefined,
            city: formValues.billingCity || undefined,
            state: formValues.billingState || undefined,
            country: formValues.billingCountry || undefined,
            postalCode: formValues.billingZip || undefined,
          },
        }),
        ownerName: formValues.owner || undefined,
        parentClientId: formValues.linkEntity?.length ? formValues.linkEntity : undefined,
        enterpriseName: formValues.loanOutCompany || undefined,
      };
      const res = await HuddleClientService.createClientV2(payload);
      sessionStorage.setItem('new-client', res?.clientId || res?.recordId || '');
      sessionStorage.setItem('platform', 'huddle');
      navigate(-1);
    } catch (err) {
      console.error('Failed to create client', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ClientFormPage
      isEdit={false}
      onSubmit={handleSubmit}
      submitting={submitting}
      primaryLabel={isValid ? 'Create Client' : undefined}
      primaryDisabled={!isValid}
    >
      <ClientForm onChange={handleChange} />
    </ClientFormPage>
  );
};

export default ClientNew;
